export const getAuthToken = () => localStorage.getItem('token');

export const getAuthHeaders = (includeContentType = false) => {
  const token = getAuthToken();
  const headers = {};
  if (includeContentType) headers['Content-Type'] = 'application/json';
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};
